import { useEffect } from "react";

/**
 * Shift key hook.
 *
 * https://stackoverflow.com/a/59963095
 * https://creativecommons.org/licenses/by-sa/4.0/
 */
const useShiftKey = (onShift: (isDown: boolean) => void) => {
	useEffect(() => {
		const handleShift = (event: any) => {
			if (event.key === "Shift") onShift(event.type === "keydown");
		};
		window.addEventListener("keydown", handleShift);
		window.addEventListener("keyup", handleShift);

		return () => {
			window.removeEventListener("keydown", handleShift);
			window.removeEventListener("keyup", handleShift);
		};
	}, [onShift]);
};

export default useShiftKey;
